import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ContentService } from './shared/services/content.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SweetAlert } from "sweetalert/typings/core";
import { Subscription } from 'rxjs';
const swal: SweetAlert = require("sweetalert");

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  isLoading = false;
  isAdminPage = false;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public contentService: ContentService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Subscribe to loader status
    const loaderSub = this.contentService.loaderSubscriber.subscribe((res: any) => {

      this.isLoading = res;
      this.cdr.detectChanges(); 
      // console.log('Loader Res: ', this.isLoading);
    });
    this.subscriptions.add(loaderSub);

    // Listen to router events
    const routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isAdminPage = this.router.url.includes('admin/') || this.router.url.includes('admin/loan');
      }
    });
    this.subscriptions.add(routerSub);
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    this.subscriptions.unsubscribe();
  }
}
